import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef
} from '@angular/core';
import { Survey, Question, ReplyItem } from '../../../../classes';
import { RepliesService } from '../../../../services';
import { filter } from 'rxjs/operators';

@Component({
  selector: '[table-regular-row]',
  templateUrl: './regular-row.component.html',
  styleUrls: ['./regular-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegularRowComponent implements OnInit {
  @Input() survey: Survey;
  @Input() item: ReplyItem;
  @Input() index: number;
  constructor(
    private repliesService: RepliesService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.survey.onContentUpdate.subscribe(()=>{
      this.cdRef.detectChanges()
    })
    this.repliesService.store.onChange
      .pipe(filter(reply_id => reply_id == this.item.id))
      .subscribe(() => {
        this.cdRef.detectChanges();
      });
  }
  ngOnDestroy() {
    // this.subscriptions.forEach(sub=>sub.unsubscribe());
  }
  prettify(question: Question) {
    return this.repliesService.prettify(question, this.item);
  }
  TrackByIdFn(index, item) {
    return item.id;
  }

  onOpenChange($event: boolean) {}
}
